import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GATE_ENABLED, gateEnabled } from "@/config";

// Public app config (GET /api/config/public): { turnstile: { enabled, site_key }, ... }.
// Module-cached so every auth form shares a single fetch (no React Query dependency
// on public routes).
let cache = null;
let inflight = null;

export function usePublicConfig() {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => {
    if (cache) return;
    if (!inflight) inflight = api.getPublicConfig().then((d) => (cache = d || {})).catch(() => ({}));
    let alive = true;
    inflight.then((d) => alive && setCfg(d));
    return () => {
      alive = false;
    };
  }, []);
  return cfg;
}

// Resolve Turnstile config for an auth form. Until config loads we assume the widget
// is required (production launches in enforce mode) and fall back to the build-time key.
export function useTurnstile() {
  const cfg = usePublicConfig();
  const ts = cfg?.turnstile;
  // Assume required until config explicitly disables it (prod launches in enforce mode).
  return {
    enabled: ts?.enabled === false ? false : true,
    siteKey: ts?.site_key || process.env.REACT_APP_TURNSTILE_SITE_KEY || "",
  };
}

// Pre-launch lockout state. True → the app is gated (private beta): signups + invites must be
// bounced to the waitlist, nobody new gets in. Un-gates automatically the moment the backend
// reports launched (GET /config/public) with no rebuild; falls back to the build-time flag
// (and fail-closed: stays gated) until config resolves.
export function useGated() {
  const cfg = usePublicConfig();
  return cfg == null ? GATE_ENABLED : gateEnabled(cfg);
}
